import { useCallback } from 'react';

/** A `retry` for ErrorView from a query's `refetch`: the promise never goes unhandled. */
export function useRetry(refetch: () => Promise<unknown>): () => void {
  return useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);
}
